import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import ReCAPTCHA from "react-google-recaptcha";
import { useStateValue, actionTypes } from '../../store';
import { googleCaptchaAPIKey, productEnquiries } from '../../networkCalls';

// Danger detection helpers: SQL-like tokens and HTML tags (client-side UX checks only)
const containsSQLLikePattern = (str = "") => {
    if (!str || typeof str !== "string") return false;
    return /(--|;|\/\*|\*\/|@@|@|\b(select|insert|update|delete|drop|alter|create|shutdown|truncate|exec|declare|union)\b)/i.test(str);
};
const containsHTMLTag = (str = "") => {
    if (!str || typeof str !== "string") return false;
    return /<[^>]+>/i.test(str);
};
const containsUnsafePattern = (str = "") => containsSQLLikePattern(str) || containsHTMLTag(str);

const validationSchema = yup.object({
    cname: yup
        .string('Enter your Name')
        .required('Name is required')
        .max(100, 'Name too long')
        .test('no-unsafe', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Enter your email')
        .max(100, 'Email too long')
        .test('no-unsafe-email', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    mobile: yup
        .string('')
        //.notRequired()
        .required()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(10, 'Enter 10 digit mobile number')
        .max(10, 'Enter 10 digit mobile number'),
    comments: yup
        .string('')
        .notRequired()
        .max(500, 'Comments too long')
        .test('no-unsafe-comments', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),

});

const ProductNotify = ({ category, model }) => {
    const [{ token, huid }, dispatch] = useStateValue();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const [openEnq, setopenEnq] = React.useState(false);
    const handleOpenEnq = () => setopenEnq(true);
    const handleCloseEnq = () => setopenEnq(false);
    // capcha code
    const TEST_SITE_KEY = googleCaptchaAPIKey;
    const recaptchaRef = React.createRef();
    const [captchavalue, setCaptchavalue] = React.useState('');
    const onVerifyCaptcha = captchavalue => {
        setCaptchavalue({ captchavalue });
    };
    // end capcha code
    const [errMessage, setErrMessage] = useState('');

    const enabledbtn = captchavalue != '';
    const formik = useFormik({
        initialValues: {
            likeTo: '',
            cname: '',
            email: '',
            mobile: '',
            comments: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // client-side check for unsafe content (modal-only)
            const fieldsToCheck = ['cname','mobile','email','comments'];
            for (const f of fieldsToCheck) {
                if (containsUnsafePattern(values[f])) {
                    if (formik && typeof formik.setFieldError === 'function') formik.setFieldError(f, 'Invalid characters or HTML tags detected');
                    setErrMessage('Invalid characters or HTML tags detected in input. Please remove SQL-like tokens or any HTML tags and try again.');
                    return;
                }
            }
            setErrMessage('');
            var data = new FormData();
            data.append('category', category);
            data.append('model', model);
            data.append('service', 'Sales');
            data.append('name', values.cname);
            data.append('email', values.email);
            data.append('mobile', values.mobile);
            data.append('state', '');
            data.append('city', '');
            data.append('comments', values.comments);
            productEnquiries(data).then((res) => {
                switch (res.data.status) {
                    case 1:
                        //setResultData(res.data.ProductList);
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        setopenEnq(false);
                        return true;
                    case 0:
                        //setResultData(res.data.ProductList);
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            })


        }
    });


    return (
        <>
            <div className=''>
                <Button color="error" onClick={handleOpenEnq} className="w-100" variant="contained" type="submit">
                     SEND ENQUIRY
                </Button>
            </div>
            <Modal
                open={openEnq}
                // onClose={handleCloseProfile}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...style, width: { xs: 340, sm: 760 }, }}>
                    <IconButton
                        onClick={handleCloseEnq}
                        size="medium"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{ float: 'right', position: 'absolute', right: '20px', top: '20px', zIndex: '3' }}
                    >
                        <CancelIcon />
                    </IconButton>
                    <div style={{ maxHeight: '550px', overflow: 'auto' }}>
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>NOTIFY</span> <span className='txtdgray'>ME</span>
                                </h4>
                            </div>
                        </div>
                        <form onSubmit={formik.handleSubmit} autoComplete="off">
                            {errMessage ? <div className="alert alert-danger">{errMessage}</div> : null}
                            <div className='row'>
                                <div className='col-12 col-md-6'>
                                    <TextField
                                        required
                                        className='mb-3 w-100'
                                        variant="standard"
                                        id="cname"
                                        name="cname"
                                        label="Name"
                                        type="text"
                                        value={formik.values.cname}
                                        onChange={formik.handleChange}
                                        error={formik.touched.cname && Boolean(formik.errors.cname)}
                                        helperText={formik.touched.cname && formik.errors.cname}
                                    />
                                </div>
                                <div className='col-12 col-md-6'>
                                    <TextField
                                        required
                                        variant="standard"
                                        className='mb-3 w-100'
                                        label="Mobile Number"
                                        type="tel"
                                        inputProps={{
                                            maxLength: 10,
                                            inputMode: 'tel',
                                            pattern: '[0-9]*'
                                        }}
                                        id="mobile"
                                        name="mobile"
                                        value={formik.values.mobile}
                                        onChange={(e) => formik.setFieldValue('mobile', e.target.value.replace(/[^0-9]/g, ''))}
                                        error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                                        helperText={formik.touched.mobile && formik.errors.mobile}
                                    />
                                </div>
                                <div className='col-12 col-md-12'>
                                    <TextField
                                        required
                                        className='mb-3 w-100'
                                        variant="standard"
                                        id="email"
                                        name="email"
                                        label="Email ID"
                                        type="text"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </div>

                                <div className='col-12 col-md-12'>
                                    <TextField
                                        className='mb-3 w-100'
                                        variant="standard"
                                        id="comments"
                                        name="comments"
                                        label="Comments"
                                        type="text"
                                        multiline
                                        rows={2}
                                        value={formik.values.comments}
                                        onChange={formik.handleChange}
                                        error={formik.touched.comments && Boolean(formik.errors.comments)}
                                        helperText={formik.touched.comments && formik.errors.comments}
                                    />
                                </div>
                                <div className="col-md-12 col-12 mb-3">
                                    <ReCAPTCHA
                                        style={{ display: "inline-block" }}
                                        theme="light"
                                        ref={recaptchaRef}
                                        sitekey={TEST_SITE_KEY}
                                        onChange={onVerifyCaptcha}
                                        onExpired={() => {
                                            recaptchaRef.current.reset(); // here
                                            setCaptchavalue('');
                                        }}
                                    />
                                </div>
                            </div>
                            <Button color="error" disabled={!enabledbtn} variant="contained" className='w-100' type="submit">
                                SEND REQUEST
                            </Button>
                        </form>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default ProductNotify